<template>
  <div class="wavetext">
    <span
        v-for="(t, i) in parsedText"
        :key="i"
        :class="[textClass, { space: t === ' ' }]"
        :style="style(i)"
        v-html="t"
    ></span>

    <v-style>
      @keyframes {{ aniName }}{
      from{
      transform:translateY(0);
      color: {{ fromcolor }};
      }
      to{
      transform:translateY(-{{ side }});
      }
      }
    </v-style>
  </div>
</template>

<script>

export default {
  name: 'WavingText',
  components: {
    'v-style': {
      render(createElement) {
        return createElement('style', this.$slots.default);
      },
    },
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      default: '0.3',
    },
    side: {
      type: String,
      default: '90',
    },
    fontsize: {
      type: String,
      default: '50',
    },
    textClass: {
      type: String,
      default: '',
    },
    fromcolor: {
      type: String,
      default: 'white',
    },
    tocolor: {
      type: String,
      default: 'black',
    },

  },
  data() {
    return {
      innertext: [...this.text],
      aniName: `_${Math.random().toString(36).substr(2, 9)}`,
    };
  },

  computed: {
    countChar() {
      return Number(this.innertext.length);
    },
    parsedText() {
      var supers = [
        this.text.match(/\d(st)/i),
        this.text.match(/\d(nd)/i),
        this.text.match(/\d(rd)/i),
        this.text.match(/\d(th)/i),
        this.text.match(/(\[\d+\])/i)
      ].filter(x => x)
      var letters = [...this.text]
      supers.forEach(match => {
        var abbr = match[0].indexOf('[') !== 0
        var start = abbr ? match.index + 1 : match.index
        var end = start + match[1].length
        for (var i = start; i < end; i++) {
          letters[i] = `<sup>${letters[i]}</sup>`
        }
      })
      return letters
    }
  },
  mounted() {
    // console.log(this.aniName);
  },
  methods: {
    style(i) {
      const an = `animation-name:${this.aniName};`;
      const font = `font-size:${this.fontsize}px;`;
      const delay = `animation-delay:-${(this.countChar - i) * Number(this.duration) / this.countChar}s;`;
      const duration = `animation-duration:${this.duration}s;`;
      const color = `color: ${this.tocolor};`;
      return `${an} ${font} ${color} ${delay} ${duration}`;
    },
    // renderLetter(t) {
    //   return (t === ' ') ? '&nbsp;' : t;
    // },
  },
};
</script>

<style scoped>
  .wavetext span{
    display:inline-block;
    animation-iteration-count:infinite;
    animation-direction:alternate;
  }
  .wavetext span.space {
    width: 0.25em;
  }
</style>
